export default () => {
  throw Error('PageNotFound');
};
